import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from './firebase'; // Ensure the correct path
import {
    onAuthStateChanged,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signOut,
    sendEmailVerification,
    sendPasswordResetEmail,
} from 'firebase/auth';

const AuthContext = createContext();

// Custom hook for consuming the context
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Listen for authentication state changes
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
            setLoading(false); // Stop loading after state updates
        });

        return unsubscribe; // Cleanup listener on unmount
    }, []);

    // Signup function with email verification
    const signup = async (email, password) => {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await sendEmailVerification(userCredential.user, {
            url: 'https://www.motionspace.io/complete-verification', // Replace with your custom domain
            handleCodeInApp: true,
        }); // Trigger email verification
        alert('Verification email sent! Please check your inbox.');
        return userCredential;
    };

    // Login function
    const login = async (email, password) => {
        return signInWithEmailAndPassword(auth, email, password);
    };

    // Logout function
    const logout = async () => {
        return signOut(auth);
    };

    // Reset password function with ActionCodeSettings
    const resetPassword = async (email) => {
        const actionCodeSettings = {
            url: 'https://www.motionspace.io/reset-password', // Replace with your custom domain
            handleCodeInApp: true,
        };

        try {
            await sendPasswordResetEmail(auth, email, actionCodeSettings);
            alert('Password reset email sent! Please check your inbox.');
        } catch (error) {
            console.error('Error sending password reset email:', error.message);
            throw error; // Re-throw error for further handling in components
        }
    };

    const value = {
        currentUser,
        signup,
        login,
        logout,
        resetPassword, // Expose the reset password function
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children} {/* Render children only after loading */}
        </AuthContext.Provider>
    );
};